import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { ImageCropperPopupComponent } from './components/image-cropper-popup/image-cropper-popup.component';
import { ImageUploadComponent } from './components/image-upload/image-upload.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { TimePickerComponent } from './components/time-picker/time-picker.component';
import { TimeParseDirective } from './directives/time-parse.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NoTransactionComponent } from './components/no-transaction/no-transaction.component';

import { LoaderModule } from './components/loader/loader.module';
import { ProfileCardComponent } from './components/profile-card/profile-card.component';
import { ControllableProfileDirective } from './directives/controllable-profile/controllable-profile.directive';
import { YesNoDialogBoxModule } from './components/yes-no-dialog-box/yes-no-dialog-box.module';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { QRCodeModule } from 'angularx-qrcode';
import { TranslationKeyPipe, FlexibleNumberPipe, CurrencyScalePipe } from './pipes/';
import { BusinessLimitationDirective } from './directives/business-limitation/business-limitation.directive';

const customComponents = [
  ImageCropperPopupComponent,
  ImageUploadComponent,
  TimePickerComponent,
  NoTransactionComponent,
  ProfileCardComponent
];

const customDirectives = [
  TimeParseDirective,
  ControllableProfileDirective,
  BusinessLimitationDirective
];

@NgModule({
  declarations: [
    customComponents,
    customDirectives,
    FlexibleNumberPipe,
    ProfileCardComponent,
    CurrencyScalePipe,
    TranslationKeyPipe,
    BusinessLimitationDirective,
  ],
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    PerfectScrollbarModule,
    ImageCropperModule,
    LoaderModule,
    YesNoDialogBoxModule,
    AngularSvgIconModule,
    QRCodeModule
  ],
  exports: [
    PerfectScrollbarModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    CommonModule,
    customComponents,
    customDirectives,
    FlexibleNumberPipe,
    LoaderModule,
    CurrencyScalePipe,
    YesNoDialogBoxModule,
    AngularSvgIconModule,
    TranslationKeyPipe
  ],
})
export class SharedModule { }
